import { render, staticRenderFns } from "./RiderDashboard.vue?vue&type=template&id=d6742b20&scoped=true"
import script from "./RiderDashboard.vue?vue&type=script&lang=js"
export * from "./RiderDashboard.vue?vue&type=script&lang=js"
import style0 from "./RiderDashboard.vue?vue&type=style&index=0&id=d6742b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6742b20",
  null
  
)

export default component.exports